import { AvailableRoles } from '@/types';
import { User } from '@/types/api';

export const hasSomeRole = (user: Pick<User, 'roles'>, ...roles: AvailableRoles[]): boolean => {
  return roles.some((role) => (user.roles || []).some((userRole) => userRole.value === role));
};

export const formatRole = (role: AvailableRoles): string =>
  (role.split('.')[1] || '').toLowerCase().replaceAll('_', ' ') || role;
